var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodingExamEntrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 128,
    viewBox: "0 0 211 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.556 38.9353H77.5767V9.47266H133.556V38.9353Z",
    fill: "#90B1FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.058 65.8818H88.9066C88.0085 65.8818 87.1473 66.239 86.5123 66.8748C85.8773 67.5105 85.5205 68.3728 85.5205 69.2718C85.5205 70.1709 85.8773 71.0332 86.5123 71.6689C87.1473 72.3047 88.0085 72.6618 88.9066 72.6618H122.061C122.959 72.6618 123.82 72.3047 124.455 71.6689C125.09 71.0332 125.447 70.1709 125.447 69.2718C125.447 68.3728 125.09 67.5105 124.455 66.8748C123.82 66.239 122.959 65.8818 122.061 65.8818H122.058Z",
    fill: "#90B1FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6328 84.7624H12.6575C12.2128 84.7628 11.7723 84.6753 11.3614 84.5051C10.9504 84.3348 10.577 84.0851 10.2625 83.7703C9.948 83.4554 9.69859 83.0816 9.52855 82.6701C9.3585 82.2587 9.27115 81.8177 9.27149 81.3724C9.27132 80.9272 9.35879 80.4863 9.52889 80.0749C9.699 79.6636 9.9484 79.2898 10.2629 78.975C10.5773 78.6601 10.9507 78.4104 11.3616 78.2401C11.7724 78.0698 12.2128 77.9823 12.6575 77.9824H32.6328C33.5308 77.9824 34.3921 78.3396 35.0271 78.9753C35.6621 79.6111 36.0188 80.4733 36.0188 81.3724C36.0188 82.2715 35.6621 83.1338 35.0271 83.7695C34.3921 84.4053 33.5308 84.7624 32.6328 84.7624Z",
    fill: "#90B1FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.541 63.5915H166.126C165.448 63.5779 164.781 63.7686 164.213 64.139C163.645 64.5093 163.201 65.0422 162.939 65.6684C162.72 66.1888 162.635 66.7556 162.69 67.3173C162.746 67.8791 162.941 68.418 163.258 68.8851C163.575 69.3523 164.003 69.7328 164.504 69.9921C165.004 70.2515 165.562 70.3814 166.126 70.3702H185.541C186.219 70.3838 186.885 70.1931 187.454 69.8228C188.022 69.4524 188.466 68.9195 188.728 68.2933C188.947 67.773 189.032 67.2062 188.976 66.6444C188.921 66.0826 188.725 65.5437 188.409 65.0766C188.092 64.6095 187.664 64.2289 187.163 63.9696C186.662 63.7102 186.105 63.5803 185.541 63.5915Z",
    fill: "#90B1FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2368 14.9568C39.2368 15.8299 38.8904 16.6672 38.2738 17.2845C37.6572 17.9018 36.8209 18.2487 35.9489 18.2487C35.0768 18.2487 34.2405 17.9018 33.6239 17.2845C33.0073 16.6672 32.6609 15.8299 32.6609 14.9568C32.6609 14.0838 33.0073 13.2465 33.6239 12.6292C34.2405 12.0119 35.0768 11.665 35.9489 11.665C36.8209 11.665 37.6572 12.0119 38.2738 12.6292C38.8904 13.2465 39.2368 14.0838 39.2368 14.9568Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8704 126.392H170.099C172.896 126.393 175.665 125.842 178.248 124.771C180.832 123.7 183.179 122.13 185.156 120.151C187.134 118.171 188.702 115.821 189.772 113.234C190.841 110.648 191.391 107.875 191.39 105.076V99.0264",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.243 126.392H41.0138C38.2176 126.393 35.4486 125.842 32.865 124.771C30.2815 123.7 27.934 122.13 25.9568 120.151C23.9796 118.171 22.4113 115.821 21.3417 113.234C20.2721 110.648 19.7221 107.875 19.7231 105.076V99.0264",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M191.392 58.053V22.1776C191.394 19.378 190.844 16.6056 189.774 14.0188C188.705 11.4321 187.137 9.08178 185.159 7.10225C183.182 5.12272 180.834 3.5528 178.251 2.48227C175.667 1.41174 172.898 0.861598 170.101 0.863285H41.0417C38.2456 0.862273 35.4767 1.41288 32.8932 2.48365C30.3097 3.55442 27.9623 5.12436 25.9851 7.10376C24.0079 9.08315 22.4396 11.4332 21.3699 14.0196C20.3003 16.6061 19.7501 19.3782 19.751 22.1776V58.0543",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.56 26.7617H191.39",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.751 26.7617H77.5818",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2368 14.9578C39.2368 15.8309 38.8904 16.6681 38.2738 17.2855C37.6572 17.9028 36.8209 18.2496 35.9489 18.2496C35.0768 18.2496 34.2405 17.9028 33.6239 17.2855C33.0073 16.6681 32.6609 15.8309 32.6609 14.9578C32.6609 14.0848 33.0073 13.2475 33.6239 12.6302C34.2405 12.0128 35.0768 11.666 35.9489 11.666C36.8209 11.666 37.6572 12.0128 38.2738 12.6302C38.8904 13.2475 39.2368 14.0848 39.2368 14.9578Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2009 14.9578C49.2009 15.8309 48.8545 16.6681 48.2379 17.2855C47.6213 17.9028 46.785 18.2496 45.913 18.2496C45.0409 18.2496 44.2046 17.9028 43.588 17.2855C42.9714 16.6681 42.625 15.8309 42.625 14.9578C42.625 14.0848 42.9714 13.2475 43.588 12.6302C44.2046 12.0128 45.0409 11.666 45.913 11.666C46.785 11.666 47.6213 12.0128 48.2379 12.6302C48.8545 13.2475 49.2009 14.0848 49.2009 14.9578Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2119 14.9578C59.2119 15.8309 58.8655 16.6681 58.2489 17.2855C57.6323 17.9028 56.796 18.2496 55.924 18.2496C55.0519 18.2496 54.2156 17.9028 53.599 17.2855C52.9824 16.6681 52.636 15.8309 52.636 14.9578C52.636 14.0848 52.9824 13.2475 53.599 12.6302C54.2156 12.0128 55.0519 11.666 55.924 11.666C56.796 11.666 57.6323 12.0128 58.2489 12.6302C58.8655 13.2475 59.2119 14.0848 59.2119 14.9578Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4342 99.0254H1.43042V58.0527H57.4342V99.0254Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1966 99.0254H77.5793V58.0527H133.559V99.0254H90.0012",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M209.684 99.0254H153.705V58.0527H209.684V99.0254Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M133.559 38.9343H77.5793V9.47168H133.559V38.9343Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105.571 38.9355V58.0548",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.405 38.9355V48.4946H181.695V58.0548",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7094 38.9355V48.4946H29.4451V58.0548",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.503 29.7138L88.9324 23.935L100.357 18.4707",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M110.783 29.7626L122.208 23.885L110.637 18.5195",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M109.515 13.6914L101.476 34.713",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8167 72.6615C46.7146 72.6615 47.5757 72.3044 48.2105 71.6688C48.8454 71.0332 49.2021 70.1711 49.2021 69.2721C49.2021 68.3732 48.8454 67.5111 48.2105 66.8755C47.5757 66.2399 46.7146 65.8828 45.8167 65.8828H12.687C12.2328 65.8675 11.7802 65.9438 11.3561 66.1072C10.932 66.2706 10.5451 66.5178 10.2184 66.8341C9.89166 67.1503 9.63186 67.5292 9.45442 67.948C9.27699 68.3669 9.18555 68.8172 9.18555 69.2721C9.18555 69.7271 9.27699 70.1774 9.45442 70.5963C9.63186 71.0151 9.89166 71.394 10.2184 71.7102C10.5451 72.0265 10.932 72.2736 11.3561 72.4371C11.7802 72.6005 12.2328 72.6768 12.687 72.6615H45.8167Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M122.061 65.8809C122.959 65.8809 123.82 66.238 124.455 66.8738C125.09 67.5095 125.447 68.3718 125.447 69.2709C125.447 70.17 125.09 71.0322 124.455 71.668C123.82 72.3037 122.959 72.6609 122.061 72.6609H88.9093C88.0112 72.6609 87.15 72.3037 86.515 71.668C85.8799 71.0322 85.5232 70.17 85.5232 69.2709C85.5232 68.3718 85.8799 67.5095 86.515 66.8738C87.15 66.238 88.0112 65.8809 88.9093 65.8809H122.061Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6358 77.9827C33.306 77.9854 33.9604 78.1865 34.5168 78.5607C35.0731 78.9349 35.5065 79.4655 35.7624 80.0857C36.0182 80.7058 36.0852 81.3879 35.9548 82.0461C35.8244 82.7043 35.5024 83.3092 35.0295 83.7846C34.7145 84.0975 34.3409 84.345 33.9301 84.5129C33.5193 84.6807 33.0794 84.7657 32.6358 84.7627H12.6849C12.2324 84.7752 11.782 84.6967 11.3603 84.532C10.9386 84.3672 10.5541 84.1195 10.2297 83.8035C9.90519 83.4875 9.64729 83.1095 9.47118 82.692C9.29508 82.2745 9.20435 81.8259 9.20435 81.3727C9.20435 80.9195 9.29508 80.4709 9.47118 80.0534C9.64729 79.6359 9.90519 79.258 10.2297 78.942C10.5541 78.626 10.9386 78.3782 11.3603 78.2135C11.782 78.0487 12.2324 77.9703 12.6849 77.9827H32.6358Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M185.544 63.5925C186.222 63.5789 186.888 63.7696 187.456 64.1399C188.025 64.5103 188.469 65.0432 188.731 65.6694C188.949 66.1897 189.035 66.7565 188.979 67.3183C188.923 67.8801 188.728 68.419 188.412 68.8861C188.095 69.3532 187.667 69.7338 187.166 69.9931C186.665 70.2525 186.107 70.3824 185.544 70.3712H166.129C165.451 70.3848 164.784 70.1941 164.216 69.8237C163.647 69.4534 163.203 68.9205 162.941 68.2943C162.723 67.7739 162.637 67.2071 162.693 66.6454C162.749 66.0836 162.944 65.5447 163.261 65.0776C163.577 64.6104 164.005 64.2299 164.506 63.9706C165.007 63.7112 165.565 63.5813 166.129 63.5925H185.544Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M194.702 75.6865C195.581 75.7162 196.413 76.0864 197.024 76.719C197.635 77.3516 197.977 78.1972 197.977 79.0772C197.977 79.9571 197.635 80.8027 197.024 81.4353C196.413 82.068 195.581 82.4382 194.702 82.4678H166.128C165.25 82.4382 164.417 82.068 163.806 81.4353C163.195 80.8027 162.854 79.9571 162.854 79.0772C162.854 78.1972 163.195 77.3516 163.806 76.719C164.417 76.0864 165.25 75.7162 166.128 75.6865H194.702Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1748 43.1779L91.757 38.9355L94.1686 43.2998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M103.012 43.1779L105.594 38.9355L107.981 43.2998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M117.919 43.1779L120.501 38.9355L122.888 43.2998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M205.737 39.1982L196.992 47.8805",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M205.714 47.9082L197.018 39.1797",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06079 42.0551L9.90968 47.4937L14.4163 39.6162",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingExamEntrance);
export default __webpack_public_path__ + "static/media/coding_exam_entrance.534ed24ddeac51ff415c9ffd2d71a08f.svg";
export { ForwardRef as ReactComponent };